import React from "react";
import "./home.scss";
import { useAuth } from "../../contexts/auth";

export default function () {
  const { user } = useAuth();
  const dateString = user.user.lastLogin; // Assuming this is a valid date string

  const waitForProcess = user.user.waitForProcess
  const waitForSignatures = user.user.waitForSignatures

  const cards = user.cards || [];

  const date = new Date(dateString);

  let formattedDate;
  // Ensure the date is valid
  if (isNaN(date.getTime())) {
    // Handle the case where the date is invalid
    formattedDate = "לא זמין";
  } else {
    formattedDate = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} ${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  }

  const handleRedirect = (waitFor) => {
    window.location.href = `/#/tasks?waitFor=${waitFor}`;
  };

  return (
    <React.Fragment>
      <h2 className="content-block">Home</h2>
      <div className="content-block">
        <div className="dx-card responsive-paddings center-card">
          <div className="logos-container">
            <img
              src="https://static.wixstatic.com/media/93c46f_a4d19deed22b48caaee025953886730d.png/v1/fill/w_379,h_94,al_c,q_85,usm_0.66_1.00_0.01/93c46f_a4d19deed22b48caaee025953886730d.webp"
              alt="Girl in a jacket"
            />
          </div>
          <p>ברוך הבא לפלטפורמת התקשרות עם לקוחות.</p>
        </div>
      </div>

      <div className="button-row">
        {cards.map((card, index) => (
          <button
            key={index}
            onClick={() => handleRedirect(card.redirectTo)}
              className="home-btn"
          >
            <div className="content-block">
              <div className="dx-card responsive-paddings">
                <div className="count-number">{card.value || 0}</div>
                <div className="count-text">{card.name}</div>
              </div>
            </div>
          </button>
        ))}
      </div>




      <div style={{ display: "flex", alignItems: "center" }}>
        <span className="icon-last-login" style={{ fontSize: "1.2rem", color: "#888", marginRight: "8px" }}>
          🕒
        </span>
        <p style={{ margin: 0 }}>
          התחברות אחרונה: {formattedDate || "לא זמין"} {/* Displays "לא זמין" if formattedDate is falsy */}
        </p>
      </div>

    </React.Fragment>
  );
}
